/**
 * Maps navigation item labels to their corresponding IDs for QA testing.
 * Returns the appropriate ID based on the label and context (main sidebar vs extended sidebar).
 */
export function getNavItemId(
  label: string,
  isExtended: boolean = false
): string {
  const prefix = isExtended ? 'sidebar-extended-link' : 'sidebar-link';

  // Special cases for main sidebar
  if (!isExtended) {
    const mainSidebarMap: Record<string, string> = {
      Home: 'sidebar-link-home',
      'Get Started': 'sidebar-link-home', // Maps to home as well
      'Market Analyzer': 'sidebar-link-market-analyzer',
      'Score Lookup': 'sidebar-link-score-lookup',
      Predictions: 'sidebar-link-predictions',
      'Data Studio': 'sidebar-link-data-studio',
      Mapping: 'sidebar-link-mapping',
      Integrations: 'sidebar-link-integrations',
      Settings: 'sidebar-link-settings',
      'Help & Support': 'sidebar-link-help',
      'SuperKudu Admin': 'sidebar-link-admin',
      'Open Sales Copilot': 'sidebar-button-open-sales-copilot',
    };

    if (mainSidebarMap[label]) {
      return mainSidebarMap[label];
    }
  }

  // Special cases for extended sidebar (settings)
  if (isExtended) {
    const extendedSidebarMap: Record<string, string> = {
      'My Profile': 'sidebar-extended-link-profile',
      'My API Keys': 'sidebar-extended-link-api-keys',
      Authentication: 'sidebar-extended-link-authentication',
      'Users & Teams': 'sidebar-extended-link-users',
      Account: 'sidebar-extended-link-account',
      'API Usage': 'sidebar-extended-link-usage',
      Admin: 'sidebar-extended-link-admin',
      Processes: 'sidebar-extended-link-processes',
    };

    if (extendedSidebarMap[label]) {
      return extendedSidebarMap[label];
    }
  }

  // Fallback: convert label to kebab-case
  return `${prefix}-${label
    .toLowerCase()
    .replace(/[&]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')}`;
}
